import actions from './UserActions'
import mutations from './UserMutations'

export default {
  state: {
    isLoggedIn: false,
    userName: '',
    UserMessageStatus: '',
    UserSnackbarColor: 'red'
  },
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js